import ShopSettingsButton from './shop-settings-button';

export default ShopSettingsButton;
